'use strict'

module.exports = '@resolver'



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/filter-resolvers/resolverKey.js